import { createFileRoute, Outlet } from '@tanstack/react-router';

import { TemplatesSidebar } from '@/app/navigation/TemplatesSidebar';
import type { PageStaticData } from '@/shared/routing';
import { SidebarRouteLayout } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// The pages beside the Templates sidebar; the calculation template's create and edit pages stay outside this group.
export const Route = createFileRoute('/_authenticated/templates/_sidebar')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarRouteLayout sidebar={<TemplatesSidebar />}>
            <Outlet />
        </SidebarRouteLayout>
    );
}
